import { render, staticRenderFns } from "./monitorAvisos.vue?vue&type=template&id=7c279974&scoped=true&"
import script from "./monitorAvisos.vue?vue&type=script&lang=js&"
export * from "./monitorAvisos.vue?vue&type=script&lang=js&"
import style0 from "./monitorAvisos.vue?vue&type=style&index=0&id=7c279974&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c279974",
  null
  
)

export default component.exports